import React from 'react';
import palette from '../../color-palette';

interface VegetarianTagProps {
  background?: string;
  tag?: string;
  className?: string;
}

const VegetarianTag = ({
  background = palette.background.default,
  tag = palette.secondary.main,
  className,
}: VegetarianTagProps) => (
  <svg
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 14 14"
    width="20"
    height="25"
    xmlSpace="preserve"
    data-testid="vegetarian-tag"
    className={className}
    fill={background}
    aria-label="vegetarian tag"
  >
    <g>
      <circle stroke={tag} cx="7" cy="7" r="6.27" />
      <path
        fill={tag}
        d="M4.46,3.65h1.46l1.04,4.88h0.02l1.17-4.88h1.38l-1.78,6.71H6.12L4.46,3.65z"
      />
    </g>
  </svg>
);

export default VegetarianTag;
